// @flow
import styled from "styled-components";

export const Form = styled.div`
    & > div {
        margin: 20px;
    }
`;
export const Title = styled.div`
    font-size: 25px;
    font-weight: bold;
`;
export const SearchResults = styled.div``;
export const SearchResult = styled.div`
    color: rgb(117, 117, 117);
    font-size: 15px;
    font-weight: 400;
    line-height: 1;
    cursor: pointer;
    white-space: nowrap;
    text-overflow: ellipsis;
    box-sizing: border-box;
    padding: 12px;
    overflow: hidden;
`;
export const Text = styled.div`
    font-size: 18px;
`;
export const Buttons = styled.div`
    & > button {
        margin-right: 20px;
    }
`;
export const SpinnerWrapper = styled.div`
    display: inline;
    position: absolute;
    margin-top: 2px;
`;



// WEBPACK FOOTER //
// ./src/write-journal-dialog/styled.js